import React from 'react';
import PropTypes from 'prop-types';

import DynamicForm from '../Models/DynamicForm';
import Section from '../Models/Section';
import Field, { FIELDS_WITH_AVERAGE } from '../Models/Field';
import FieldList from '../Models/FieldList';
import FieldCondition from '../Models/FieldCondition';
import FieldConditionRule from '../Models/FieldConditionRule';
import FieldOption from '../Models/FieldOption';
import Trigger from '../Models/Trigger';

import UnitOptions from '../Services/UnitOptions';
import Utils from '../Services/Utils';
import Sectors from '../Services/api/Sectors';
// import WhiteLabels from '../Services/api/Whitelabels';
import ClientInstances from '../Services/api/ClientInstances';
import PropertyOptions from '../Services/api/PropertyOptions';
import TriggerTemplates from '../Services/api/TriggerTemplates';
import ContactTypes from '../Services/api/ContactTypes';
import PmsPlatforms from '../Services/api/PmsPlatforms';
import ChargeCodes from '../Services/api/ChargeCodes';
import ModelPlaceholders from '../Services/ModelPlaceholders';
import DynamicFormService from '../Services/api/DynamicForm';
import SelectOptions from '../Services/SelectOptions';
import ConfigService from '../Services/api/Config';
import FormErrors from '../Services/FormErrors';
import TagsService from '../Services/api/TagsService';
import TranslationService from '../Services/api/TranslationService';

export const DynamicFormBuilderScreenContext = React.createContext(null);

export const SCORE_TYPE_AMOUNT = 1;
export const SCORE_TYPE_AVERAGE = 2;
export const SCORE_TYPE_MULTIPLIER = 3;

export const SCORE_OPTIONS = [
  { value: 0, label: 'No score' },
  { value: SCORE_TYPE_AMOUNT, label: 'Amount' }
];

export const SCORE_OPTIONS_WITH_MULTIPLIER = [
  { value: 0, label: 'No score' },
  { value: SCORE_TYPE_AMOUNT, label: 'Amount' },
  { value: SCORE_TYPE_MULTIPLIER, label: 'Multiplier' }
];

export const SCORE_OPTIONS_AVERAGE = [
  { value: 0, label: 'No score' },
  { value: SCORE_TYPE_AMOUNT, label: 'Amount' },
  { value: SCORE_TYPE_AVERAGE, label: 'Average' }
];

export const Section_Translated_Data = [
  'label',
  'description',
  'placeholder'
]

export const Fields_With_OPTIONS = [
  'radio',
  'checkbox',
  'select',
  'ratingScale3pt'
]

export const COLUMNS_OPTIONS = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 }
];


export let TAGS_AVAILABLE = [];
export let IS_ADMIN = false;
export class DynamicFormScreenContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loaded: false,
      configuration: null,
      oldData: null,
      data: null,
      unitFields: null,
      contactTypes: null,
      triggerTemplates: null,
      propertyFields: null,
      pmsPlatforms: null,
      chargeCodes: null,
      sectors: null,
      clientInstances: null,
      undo: false,
      initialData: null,
      modified: false,
      api: {
        init: this.init,
        onDFUpdateData: this.onDFUpdateData,
        onDFRestoreData: this.onDFRestoreData,
        onDFBasicValueChange: this.onDFBasicValueChange,
        onDFErrorChange: this.onDFErrorChange,
        onSectionValueChange: this.onSectionValueChange,
        onFieldValueChange: this.onFieldValueChange,
        getValidFieldsForConditions: this.getValidFieldsForConditions,
        submit: this.submit,
        onChangeSectionOrder: this.onChangeSectionOrder,
        onChangeFieldOrder: this.onChangeFieldOrder,
        getComponentId: this.getComponentId,
        onAddNewField: this.onAddNewField,
        onRemoveField: this.onRemoveField,
        onRemoveSection: this.onRemoveSection,
        onAddNewSection: this.onAddNewSection,
        getAllSections: this.getAllSections,
        onCloneField: this.onCloneField,
        onCloneSection: this.onCloneSection,
        setLoading: this.setLoading,
        permissionAvailableAccount: this.permissionAvailableAccount,
        permissionAvailable: this.permissionAvailable,
        resetDFData: this.resetDFData,
        FormDataChange: this.FormDataChange,
        getFieldsVerbiage : this.getFieldsVerbiage,
        handleTranslationsOnFocus: this.handleTranslationsOnFocus
      },
      availableLanguage: [],
      isEdit: false,
      localeCreated : false,
      tabs : []
    };

    this.submissionCallback = null;
    this.hasDuplicateError = false;
  }

  UNSAFE_componentWillMount() {
    ConfigService.initContextApi(this.state.api);
  }

  init = async (df, submissionCallback, accountPermissions, accountUserPermissions, isAdmin, availableLanguage, preferredLanguage, isEdit, updated_in_language) => {
    this.submissionCallback = submissionCallback;
    let clientInstances = [];
    IS_ADMIN = isAdmin;
    let sectors = [];
    this.setState({
      accountPermissions,
      accountUserPermissions
    });
    const propertyFields = await PropertyOptions.list({ disable_pagination: true });
    const triggerTemplates = await TriggerTemplates.list({
      disable_pagination: true, essential: true, account: df.account
    });
    const contactTypes = await ContactTypes.list({
      disable_pagination: true, essential: true
    });
    const tagsparams = isAdmin ? {ordering: 'tag_name'} : {ordering: 'display_name'};
    TAGS_AVAILABLE = await TagsService.list(tagsparams);
    // these will be pulled from the API as Account-level ChargeCodes
    let pmsPlatforms = [];
    let chargeCodes = [];
    if (this.permissionAvailableAccount('permission_view_charges') &&
        this.permissionAvailable('permission_define_property_charge_codes')){
      const params = !isAdmin ? { account: df.account, disable_pagination: true } : { disable_pagination: true };
      pmsPlatforms = await PmsPlatforms.list(params);
      chargeCodes = await ChargeCodes.list(params);
    }
    const data = await DynamicForm.parse(df, true, chargeCodes);
    const unitFields = UnitOptions.getOptions();
    if (df.isStaff) {
      sectors = await Sectors.list({ disable_pagination: true, essential: true });
      const parseSectors = sectors.map((item) => {
        return { value: item.id, label: item.name };
      });
      if (data && data.sectors && data.sectors.length > 0) {
        data.sectors = SelectOptions.getValue(parseSectors, data.sectors);
      }
      clientInstances = await ClientInstances.list({ disable_pagination: true, essential: true });
      const parseClientInstances = clientInstances.map((item) => {
        return { value: item.id, label: item.name };
      });
      if (data && data.clientInstance) {
        data.clientInstance = SelectOptions.getValue(parseClientInstances, data.clientInstance);
      }
    }
    let initialData;
    if (isEdit && data.locale && Object.keys(data.locale).length > 0 && data.languages && data.languages.length > 0) {
      data.updated_in_language = updated_in_language;
      let langCreated = (data.created_in_language &&  data.created_in_language.code) ? data.created_in_language.code : data.created_in_language;
      let createdInLang = availableLanguage.filter(lang => lang.code == langCreated);
      let langCodeArray = data.languages.map(lang => lang.code);
      if (!langCodeArray.includes(langCreated)) {
        this.setState({ tabs: [...createdInLang, ...data.languages] });
      }
      else {
        this.setState({ tabs: [...data.languages] });
      }
    }
    if(availableLanguage && availableLanguage.length > 0 && preferredLanguage && !(data.locale && Object.keys(data.locale).length > 0)){
      data.locale = {}
      availableLanguage.forEach(lang =>{
        data.locale[lang.code] = {};
      })
      if(!data.locale['en']) data.locale['en'] = {};
      this.setState({availableLanguage: availableLanguage})
      data.created_in_language = preferredLanguage;
      initialData = _.cloneDeep(data);
      this.setState({localeCreated: true})
      this.updateExistingForm(data, 'added', true);
    }
    this.setState({
      data,
      unitFields,
      contactTypes,
      triggerTemplates,
      propertyFields,
      chargeCodes,
      pmsPlatforms,
      sectors,
      clientInstances,
      initialData,
      availableLanguage,
      isEdit,
    });
  };

  setLoading = (loading) => {
    this.setState({
      loading: loading
    });
  };

  // will reset the DF data to initial if user decides to change the language in between of creation
  resetDFData = async (currentLanguage) =>{
    this.state.initialData.created_in_language = currentLanguage;
    let newData = _.cloneDeep(this.state.initialData);
    const data = await DynamicForm.parse(newData);
    this.updateExistingForm(data, 'added', true);
    this.setState({data : data, modified : false});
  }

  // when form name and form description changes
  FormDataChange = async (field_name) =>{
    const { data } = this.state;
    if(data.name || data.description){
      let obj = {id: 'formData', name : data.name, description: data.description, field_name: field_name};
      this.updateExistingForm(obj)
    }
  }

  onDFUpdateData = async () => {
    const { data } = this.state;
    const newData = await DynamicForm.parse(data);
    this.setState({ data: newData });
  };

  onDFRestoreData = async () => {
    const { oldData, undo } = this.state;
    if (!undo) return;
    const data = await DynamicForm.parse(oldData);
    this.updateExistingForm(data, 'added', true);
    this.setState({ data: data, undo: false });
  };

  onDFBasicValueChange = (field, value) => {
    const { data } = this.state;
    data[field] = value;
    if(field !== 'created_in_language' && field !== 'languages'){
      if(field == 'name') this.hasDuplicateError = false;
      this.setState({ data: { ...data }, modified: true });
    }
    else{
      this.setState({ data: { ...data } });
    }
  };

  // this method is created for setting value of locale name and description on name or description
  handleTranslationsOnFocus = (field_name, field_value) => {
    if(this.state.availableLanguage && this.state.availableLanguage.length >0){
      const { data } = this.state;
      data[field_name] = field_value;
      this.setState({ data: { ...data } });
    }
  }

  onDFErrorChange = (field, error) => {
    const { data } = this.state;
    if(field == 'name'){
      if(!this.hasDuplicateError || (this.hasDuplicateError && error != '' && error[field] != '')){
        data.errors[field] = error;
        this.setState({ data: { ...data } });
      }
    }
    else{
      data.errors[field] = error;
      this.setState({ data: { ...data } });
    }
  };

  onSectionValueChange = async (id, section) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    data.sections.items[id] = new Section(section);
    await this.updateExistingForm(section, 'added');
    let newData = JSON.parse(JSON.stringify(data));
    newData = await DynamicForm.parse(newData);
    this.setState({ data: { ...newData }, undo: true });
  };

  onFieldValueChange = (id, section, field, changeInverseConditions, oldOptions) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const sectionId = section || 'sectiondividerInitial';
    this.updateExistingForm(field, 'added')
    data.sections.items[sectionId].fields.items[id] = new Field(field);
    if (changeInverseConditions) {
      this.changeInverseConditions(data.sections.items[sectionId].fields.items[id], oldOptions);
    }
    this.setState({ data: { ...data }, undo: true });
  };

  getAllFields = (excludeSection) => {
    const { data } = this.state;
    const fields = [];
    data.sections.order.map((keySection) => {
      if (!excludeSection || (excludeSection !== keySection)) {
        const section = data.sections.items[keySection];
        if (section.fields) {
          section.fields.order.map((keyField) => {
            fields.push(section.fields.items[keyField]);
          });
        }
      }
    });
    return fields;
  };

  getAllSections = () => {
    const { data } = this.state;
    const fields = [];
    data.sections.order.map((keySection) => {
      fields.push(data.sections.items[keySection]);
    });
    return fields;
  };

  updateConditions = (conditions, newField, field, oldOptions) => {
    for (let i = conditions.length - 1; i >= 0; i--) {
      const condition = field.conditions[i];
      if (condition.conditionField.value === newField.id) {
        condition.conditionField.label = newField.label;
        if (Utils.isOptionsField(newField.component)) {
          const options = newField.options.map((option) => {
            return option.value;
          });
          if (Array.isArray(condition.conditionValue)) {
            let newValue = [];
            for (const value of condition.conditionValue) {
              if (options.indexOf(value.value) < 0) {
                const oldIndex = oldOptions.indexOf(value.value);
                if (!Utils.isNull(options[oldIndex])) {
                  newValue.push({ value: newField.options[oldIndex].value, label: newField.options[oldIndex].value });
                }
              } else {
                newValue.push(value);
              }
            }
            condition.conditionValue = newValue;
          } else {
            let value = (condition.conditionValue && condition.conditionValue.value) ? condition.conditionValue.value : condition.conditionValue;
            if (options.indexOf(value) < 0) {
              const oldIndex = oldOptions.indexOf(value);
              if (!Utils.isNull(options[oldIndex])) {
                condition.conditionValue = { value: newField.options[oldIndex].value, label: newField.options[oldIndex].value };
              } else {
                condition.conditionValue = null;
              }
            }
          }
          if (Utils.isEmpty(condition.conditionValue)) {
            field.conditions.splice(i, 1);
          }
        }
      }
    }
  }

  updateConditionRules = (conditionsRules, newField, field, oldOptions) => {
    for (let i = conditionsRules.length - 1; i >= 0; i--) {
      const rule = field.conditionsRules[i];
      if (rule.conditionField.value === newField.id) {
        rule.conditionField.label = newField.label;
        if (Utils.isOptionsField(newField.component)) {
          let options = newField.options.map((option) => {
            return option.value;
          });
          if (Array.isArray(rule.conditionValue)) {
            let newValue = [];
            for (const value of rule.conditionValue) {
              if (options.indexOf(value.value) < 0) {
                const oldIndex = oldOptions.indexOf(value.value);
                if (!Utils.isNull(options[oldIndex])) {
                  newValue.push({ value: newField.options[oldIndex].value, label: newField.options[oldIndex].value });
                }
              } else {
                newValue.push(value);
              }
            }
            rule.conditionValue = newValue;
          } else {
            let value = (rule.conditionValue && rule.conditionValue.value)
              ? rule.conditionValue.value
              : rule.conditionValue;
            if (options.indexOf(value) < 0) {
              const oldIndex = oldOptions.indexOf(value);
              if (!Utils.isNull(options[oldIndex])) {
                rule.conditionValue = {
                  value: newField.options[oldIndex].value,
                  label: newField.options[oldIndex].value
                };
              } else {
                rule.conditionValue = null;
              }
            }
          }
          if (Utils.isEmpty(rule.conditionValue)) {
            field.conditionsRules.splice(i, 1);
          }
        }
      } else if (field.id === newField.id) {
        if (Utils.isOptionsField(newField.component)) {
          if (Array.isArray(rule.ruleValue)) {
            for (let f = rule.ruleValue.length - 1; f >= 0; f--) {
              let value = rule.ruleValue[f];
              if (newField.options[value.value]) {
                value.label = newField.options[value.value].value;
              } else {
                rule.ruleValue.splice(f, 1);
              }
            }
          } else if (rule.ruleValue.label) {
            if (newField.options[rule.ruleValue.value]) {
              rule.ruleValue.label = newField.options[rule.ruleValue.value].value;
            } else {
              rule.ruleValue = null;
            }
          }
          if (Utils.isEmpty(rule.ruleValue)) {
            field.conditionsRules.splice(i, 1);
          }
        }
      }
    }
  }

  updateTriggers = (triggers, newField, field, oldOptions) => {
    for (let i = triggers.length - 1; i >= 0; i--) {
      let trigger = field.triggers[i];
      if (field.id === newField.id) {
        if (Utils.isOptionsField(newField.component)) {
          if (Array.isArray(trigger.conditionValue)) {
            for (let f = trigger.conditionValue.length - 1; f >= 0; f--) {
              let value = trigger.conditionValue[f];
              if (newField.options[value.value]) {
                value.label = newField.options[value.value].value;
              } else {
                trigger.conditionValue.splice(f, 1);
              }
            }
          } else if (trigger.conditionValue.label) {
            if (newField.options[trigger.conditionValue.value]) {
              trigger.conditionValue.label = newField.options[trigger.conditionValue.value].value;
            } else {
              trigger.conditionValue = null;
            }
          }
          if (Utils.isEmpty(trigger.conditionValue)) {
            field.triggers.splice(i, 1);
          }
        }
      }
    }
  }

  changeInverseConditions = (newField, oldOptions) => {
    const fields = this.getAllFields();
    const sections = this.getAllSections();
    // update conditions for fields
    for (const field of fields) {
      const conditions = field.conditions;
      const conditionsRules = field.conditionsRules;
      const triggers = field.triggers;
      this.updateConditions(conditions, newField, field, oldOptions);
      this.updateConditionRules(conditionsRules, newField, field, oldOptions);
      this.updateTriggers(triggers, newField, field, oldOptions)
    }
    // update conditions for sections 
    for (const section of sections){
      const conditions = section.conditions
      this.updateConditions(conditions, newField, section, oldOptions)
    }
  };

  deleteInverseConditions = (deletedField) => {
    const { data } = this.state;
    const fields = this.getAllFields();
    for (let field of fields) {
      const conditions = [];
      const rules = [];
      let coincidence = false;
      let newfield;

      for (const condition of field.conditions) {
        if (condition.conditionField.value !== deletedField.id) {
          conditions.push(condition);
        } else {
          coincidence = true;
        }
      }

      for (const rule of field.conditionsRules) {
        if (rule.conditionField.value !== deletedField.id) {
          rules.push(rule);
        } else {
          coincidence = true;
        }
      }

      if (coincidence) {
        newfield = new Field({ ...field, conditions: conditions, conditionsRules: rules });
        data.sections.items[field.section].fields.items[field.id] = newfield;
      }
    }
  };

  getValidFieldsForConditions = (id, rule, section) => {
    const array = [];
    let invalidFields = [
      'sectionDivider',
      'pageBreak',
      'userName',
      'freeText',
      'fileEmbedded'
    ];
    if (rule) {
      invalidFields = invalidFields.concat(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput']);
    }
    const sectionId = section ? id : null;

    for (const option of this.getAllFields(sectionId)) {
      if (option.id !== id && invalidFields.indexOf(option.component) === -1) {
        if (option.conditions && !rule) {
          let exist = false;
          for (const condition of option.conditions) {
            if (condition.conditionField === id) {
              exist = true;
            }
          }
          if (!exist) {
            array.push(option);
          }
        } else {
          array.push(option);
        }
      }
    }

    return array;
  };

  getComponentId = (id, isSection, aditionalFields = []) => {
    const fields = isSection ? this.getAllSections() : [...aditionalFields, ...this.getAllFields()];
    let ref = id;
    let i = 0;
    fields.forEach((item) => {
      const idArray = item.id.split('#');
      if (idArray[0].toLowerCase() == id.toLowerCase()) {
        if (idArray.length > 1 && parseInt(idArray[1], 10) >= i) {
          i = parseInt(idArray[1], 10) + 1;
        }
        ref = id + '#' + i;
      }
      return ref;
    });
    if (ref.split('#').length < 2) {
      ref += '#0';
    }
    return ref;
  };

  onChangeSectionOrder = (source, destination) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    data.sections.changeOrder(source, destination);
    this.setState({ data: { ...data }, undo: true });
  };

  onChangeFieldOrder = (source, destination, sourceSection, destinationSectionIndex) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const field = data.sections.items[sourceSection].fields.removeField(source);
    const destinationSection = data.sections.order[destinationSectionIndex];
    data.sections.items[destinationSection].fields.addField(destination, field, destinationSection);
    this.setState({ data: { ...data }, undo: true });
  };

  onAddNewField = (destination, destinationSectionIndex, fieldType) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const destinationSection = data.sections.order[destinationSectionIndex];
    const fieldId = this.getComponentId(fieldType);
    const fieldDefaultAttrs = ModelPlaceholders.getFieldPlaceholder(fieldType);
    if(fieldDefaultAttrs && fieldDefaultAttrs.options){
      fieldDefaultAttrs.options = fieldDefaultAttrs.options.map((option, index) => ({
        ...option,
        id: 'options#' + index,
        componentId: fieldId
      }));
    }
    const section = data.sections.items[destinationSection];
    let scoreType = section.scoreType;
    if (scoreType && !FIELDS_WITH_AVERAGE.includes(fieldType) && scoreType.value === SCORE_TYPE_AVERAGE) {
      scoreType = { value: SCORE_TYPE_AMOUNT, label: 'Amount' };
    }
    const field = new Field({ ...fieldDefaultAttrs, index: destination, id: fieldId, scoreType: scoreType, disabled: true });
    field.new = true;
    this.updateExistingForm(field, 'added')
    delete field.new;
    section.fields.addField(destination, field, destinationSection);
    this.setState({ data: { ...data }, undo: true });
  };

  onRemoveField = (source, sourceSection) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const field = data.sections.items[sourceSection].fields.removeField(source);
    this.deleteInverseConditions(field);
    this.updateExistingForm(source, 'removed')
    this.setState({ data: { ...data }, undo: true });
  };

  onAddNewSection = (destination, fieldType) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const fieldId = this.getComponentId(fieldType, true);
    const label = fieldId.split('#')[1] && fieldId.split('#')[1] > 0 ? 'Section Divider ' + fieldId.split('#')[1] : 'Section Divider';
    const fieldDefaultAttrs = ModelPlaceholders.getFieldPlaceholder(fieldType, label);
    const section = new Section({ ...fieldDefaultAttrs, index: destination, id: fieldId, scoreType: data.scoreType });
    section.new = true;
    this.updateExistingForm(section, 'added');
    data.sections.addSection(destination, section);
    this.setState({ data: { ...data }, undo: true });
  };

  onRemoveSection = (source) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    data.sections.removeSection(source);
    this.updateExistingForm(source, 'removed');
    this.setState({ data: { ...data }, undo: true });
  };

  onCloneField = (field, index) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const fieldId = this.getComponentId(field.component);
    const clonedField = new Field({ ...field, index: index, id: fieldId, originId: field.id });

    clonedField.options = (field.options || []).map(item => new FieldOption(Utils.setNewPointersOfDicsInDic(item)));
    clonedField.triggers = (field.triggers || []).map(item => new Trigger(Utils.setNewPointersOfDicsInDic(item)));
    clonedField.conditions = (field.conditions || []).map(
      item => new FieldCondition(Utils.setNewPointersOfDicsInDic(item)));
    clonedField.conditionsRules = (field.conditionsRules || []).map(
      item => new FieldConditionRule(Utils.setNewPointersOfDicsInDic(item)));
    this.updateExistingForm(clonedField, 'added');
    data.sections.items[field.section].fields.addField(index + 1, clonedField, field.section);
    this.setState({ data: { ...data }, undo: true });
  };

  onCloneSection = (section, index, clonelabel) => {
    const { data } = this.state;
    let oldData = JSON.parse(JSON.stringify(data));
    this.setState({ oldData: {...oldData } } );
    const sectionId = this.getComponentId(section.component, true);
    const label = clonelabel || this.getClonedSectionLabel(section.label);
    const newFieldList = new FieldList(this.getClonedSectionFieldList(section.fields, sectionId));
    const clonedSection = new Section(
      { ...section, label: label, id: sectionId, index: index + 1, originId: section.id, fields: newFieldList });
      if(this.state.availableLanguage && this.state.availableLanguage.length > 0 && data.locale && Object.keys(data.locale).length > 0)
      {
        Object.keys(data.locale).forEach(lang_code =>{
          clonedSection.fields['order'].forEach((field, index) => {
              section.fields['order'].forEach((oldfield , indexOld)=>{
                    if(index == indexOld){
                      Section_Translated_Data.forEach(translated_field => {
                        data.locale[lang_code][`${field}_${translated_field}`] = section.fields['items'][oldfield][lang_code][translated_field];
                      })
                      if (section.fields['items'][oldfield][lang_code] && section.fields['items'][oldfield][lang_code]['options'] && section.fields['items'][oldfield][lang_code]['options'].length > 0) {
                        section.fields['items'][oldfield][lang_code]['options'].forEach((option, index) => {
                          data.locale[lang_code][`${field}_value-${index}`] = option.label;
                        })
                      }
                    }
              })
          })
        })
      }
    this.updateExistingForm(clonedSection, 'added');
    data.sections.addSection(index + 1, clonedSection);
    this.setState({ data: { ...data }, undo: true });
  };

  getClonedSectionFieldList = (oldSectionFields, newSectionId) => {
    const fields = oldSectionFields.items;
    const fieldOrder = oldSectionFields.order;
    const newFields = [];
    const newFieldList = {
      order: [],
      items: {}
    };

    for (const key of fieldOrder) {
      const field = fields[key];
      const fieldId = this.getComponentId(field.component, false, newFields);
      newFields.push(new Field({ ...field, id: fieldId, originId: field.id, section: newSectionId }));
    }

    for (const field of newFields) {
      field.conditions = (field.conditions || []).map(condition => {
        const newCondition = new FieldCondition(Utils.setNewPointersOfDicsInDic(condition));
        if (fields[newCondition.conditionField.value]) {
          newCondition.conditionField.value = newFields.find(
            item => item.originId === newCondition.conditionField.value).id;
        }
        return newCondition;
      });
      field.conditionsRules = (field.conditionsRules || []).map(condition => {
        const newCondition = new FieldConditionRule(Utils.setNewPointersOfDicsInDic(condition));
        if (fields[newCondition.conditionField.value]) {
          newCondition.conditionField.value = newFields.find(
            item => item.originId === newCondition.conditionField.value).id;
        }
        return newCondition;
      });

      field.options = (field.options || []).map(item => new FieldOption(Utils.setNewPointersOfDicsInDic(item)));
      field.triggers = (field.triggers || []).map(item => new Trigger(Utils.setNewPointersOfDicsInDic(item)));

      newFieldList.order.push(field.id);
      newFieldList.items[field.id] = field;
    }
    return newFieldList;
  };

  getClonedSectionLabel = (sourceLabel) => {
    let sourceArr = sourceLabel.split(' ');
    let sourceIndex = sourceArr[sourceArr.length - 1];
    let newIndex = 1;
    if (!isNaN(sourceIndex)) {
      newIndex = parseInt(sourceIndex) + 1;
      sourceArr.pop();
    }

    return sourceArr.join(' ') + ' ' + newIndex;
  };

  submit = async (stay) => {
    const { data } = this.state;
    const dynamicForm = new DynamicForm(data);

    let response = null;

    const dynamicFormData = await DynamicFormService.list({
      account: data.account, name__iexact: data.name
    });
    const result = dynamicFormData.filter(({ id }) => id === data.id);

    if (dynamicFormData.length === result.length) {
      let Df = await dynamicForm.serializeAsync(true);
      Df.created_in_language = Df.created_in_language ? Df.created_in_language.code : null;
      if (data.id) {
        Df.languages = Array.isArray(Df.languages) ? Df.languages.map(v => { return v.value}) : [];
        if(!(Df.languages && Df.languages.length > 0)) delete Df.locale;
        response = await DynamicFormService.update(data.id, Df);
      } else {
        Df.languages = Array.isArray(Df.languages) ? Df.languages.map(v => { return v.value}) : [];
        if(!(Df.languages && Df.languages.length > 0)) delete Df.locale;
        response = await DynamicFormService.create(Df);
      }
      this.setState({ undo: false});
      this.submissionCallback(response, stay);
    } else {
      this.hasDuplicateError = true;
      this.onDFErrorChange('name', 'This dynamic form already exists.');
      FormErrors.goToError();
    }
  };

  permissionAvailableAccount = (permission) => {
    const { accountPermissions } = this.state;
    return accountPermissions && accountPermissions[permission];
  };

  permissionAvailable = (permission) => {
    const { accountUserPermissions } = this.state;
    return accountUserPermissions && (accountUserPermissions.is_owner || accountUserPermissions[permission]);
  };

  updateExistingForm = async (field, action, fromInit) => {
    if(this.state.availableLanguage && this.state.availableLanguage.length > 0){
      let error = false;
      let { data } = this.state;
      if (fromInit) {
        data = field
      }
      if (data.locale && Object.keys(data.locale).length > 0) {
        if (action == 'removed') {
          Section_Translated_Data.forEach(fields => {
            Object.keys(data.locale).forEach(key => {
              delete data.locale[key][`${field.id}_${fields}`];
            })
          })
        }
        else {
          // for creation only always if statement will be executed and for Edit DF on adding new field or updating the translation in same created language
          if (!this.state.isEdit || this.state.localeCreated || field.new || data.created_in_language.code == data.updated_in_language) {
            let context = {};
            // for initially creating the locale in case of creation
            if (fromInit) {
              context = [];
              context.push({ id: 'formData', name: data.name, description: data.description });
              Object.keys(data.sections.items).forEach((sectionItem) => {
                context.push({ id: sectionItem, label: data.sections.items[sectionItem].label, description: data.sections.items[sectionItem].description })
                if (data.sections.items[sectionItem].fields && Object.keys(data.sections.items[sectionItem].fields.items).length > 0) {
                  let allFields = data.sections.items[sectionItem].fields.items;
                  Object.keys(allFields).forEach(field => {
                    let fieldContext = { id: field }
                    Section_Translated_Data.forEach(translated_data => {
                      fieldContext[translated_data] = allFields[field][translated_data];
                    })
                    if (Fields_With_OPTIONS.includes(allFields[field].component)) {
                      fieldContext['options'] = allFields[field]['options'];
                    }
                    context.push(fieldContext);
                  })
  
                }
              })
            }
            else {
              if (field.id == 'formData') {
                context = field
              }
              else {
                let fieldContext = { id: field.id }
                Section_Translated_Data.forEach(translated_data => {
                  fieldContext[translated_data] = field[translated_data];
                })
                if (Fields_With_OPTIONS.includes(field.component)) {
                  fieldContext['options'] = field['options'];
                }
                context = fieldContext;
              }
            }
            let translate_lang = [];
            if (!this.state.localeCreated && !field.new) {
              translate_lang = data.languages.filter((i) => {
                return (i.code != data.updated_in_language)
              }).map((lang) => {
                { return lang.code }
              });;
            }
            else {
              translate_lang = this.state.availableLanguage.filter((i) => {
                return (i.code != data.created_in_language.code)
              }).map((lang) => {
                { return lang.code }
              });
            }
            let request = {
              original_lang: (!this.state.localeCreated && !field.new) ? data.updated_in_language : data.created_in_language ? data.created_in_language.code : null,
              translate_lang: (translate_lang && translate_lang.length > 0) ? translate_lang : ['en'],
              context: context
            }
            this.setLoading(true);
            await TranslationService.getTranslations(request).then(res => {
              if (res && res.context && Object.keys(res.context).length > 0) {
                // for multiple fields at a time
                if (fromInit) {
                  res.context.forEach(con => {
                    Object.keys(con).forEach(field_id => {
                      con[field_id].forEach(obj => {
                        Object.keys(obj).forEach(lang_code => {
                          if(obj[lang_code].id == 'formData'){
                            data.locale[lang_code]['name'] = obj[lang_code]['name']
                            data.locale[lang_code]['description'] = obj[lang_code]['description']
                          }
                          else {
                            Section_Translated_Data.forEach(translated_field => {
                              data.locale[lang_code][`${field_id}_${translated_field}`] = obj[lang_code][translated_field];
                            })
                            if (obj[lang_code]['options'] && obj[lang_code]['options'].length > 0) {
                              obj[lang_code]['options'].forEach((option, index) => {
                                data.locale[lang_code][`${field_id}_value-${index}`] = option.value;
                              })
                            }
                          }
                        })
                      })
                    })
                  })
                }
                // for single field at a time
                else {
                  res.context.forEach(translated_data => {
                    translated_data.forEach(loc => {
                      Object.keys(loc).forEach(lang_code => {
                        if(loc[lang_code].id == 'formData'){
                          data.locale[lang_code][field.field_name] = loc[lang_code][field.field_name]
                        }
                        else {
                          Section_Translated_Data.forEach(translated_field => {
                            data.locale[lang_code][`${loc[lang_code].id}_${translated_field}`] = loc[lang_code][translated_field];
                          })
                          if (loc[lang_code]['options'] && loc[lang_code]['options'].length > 0) {
                            loc[lang_code]['options'].forEach((option, index) => {
                              data.locale[lang_code][`${loc[lang_code].id}_value-${index}`] = option.value;
                            })
                          }
                        }
                      })
                    })
                  })
                }
              }
              else {
                this.setLoading(false);
                error = true
              }
  
            }).catch(err => {
              this.setLoading(false);
              error = true
            });
          }
          else {
            //update only translation if created_in_language is different from updated_in_language in case of Edit DF
            if (field.id == 'formData') {
              data.locale[data.updated_in_language][field.field_name] = field[field.field_name];
            }
            else {
              Section_Translated_Data.forEach(fields => {
                data.locale[data.updated_in_language][`${field.id}_${fields}`] = field[fields];
              })
              if (field.options) {
                field.options.forEach((option, index) => {
                  data.locale[data.updated_in_language][`${field.id}_value-${index}`] = option.value;
                })
              }
            }
          }
  
          // then update the label descrption as well if language not equal to english
          if ((!error && !this.state.localeCreated && data.updated_in_language && (data.created_in_language && data.created_in_language.code) && (data.updated_in_language != data.created_in_language.code))) {
            if (field.id == 'formData') {
              data[field.field_name] = data.locale[data.created_in_language.code][field.field_name];
            }
            else {
              Section_Translated_Data.forEach(key => {
                field[key] = data.locale[data.created_in_language.code][`${field.id}_${key}`];
              })
              if (field.options) {
                field.options.forEach((option, index) => {
                  option.value = data.locale[data.created_in_language.code][`${field.id}_value-${index}`];
                })
              }
            }
          }
          if (fromInit) {
            if(error && this.state.localeCreated) data.locale = {};
            this.setState({ data: { ...data }, loading: false, modified: false });
          }
          else {
            this.setState({ data: { ...data }, loading: false, modified: true });
          }
        }
      }
    }
   
  }

  getFieldsVerbiage = (field, key) => {
    const { data } = this.state;
    if(this.state.availableLanguage && this.state.availableLanguage.length > 0){
      if (field.disabled && field.previewLanguage && field[field.previewLanguage.code] && field[field.previewLanguage.code][key]) {
        // if key is equal to options then default this 
        if (key == 'options') {
          return field[field.previewLanguage.code].options.map((item, index) => { return { value: index, label: item.label }; })
        }
        else if(key == 'defaultOptions') {
          return field[field.previewLanguage.code].options.map((item, index) => { return { value: item.label, label: item.label }; })
        }
        return field[field.previewLanguage.code][key];
      }
      else if (data.updated_in_language && field[data.updated_in_language] && field[data.updated_in_language][key]) {
        // if key is equal to options then default this 
        if (key == 'options') {
          return field[data.updated_in_language].options.map((item, index) => { return { value: index, label: item.label }; })
        }
        else if(key = 'defaultOptions') {
          return field[data.updated_in_language].options.map((item, index) => { return { value: item.label, label: item.label }; })
        }
        return field[data.updated_in_language][key];
      }
      else if (data.created_in_language && data.created_in_language.code && field[data.created_in_language.code] && field[data.created_in_language.code][key]) {
        // if key is equal to options then default this 
        if (key == 'options') {
          return field[data.created_in_language.code].options.map((item, index) => { return { value: index, label: item.label }; })
        }
        else if(key == 'defaultOptions') {
          return field[data.created_in_language.code].options.map((item, index) => { return { value: item.label, label: item.label }; })
        }
        return field[data.created_in_language.code][key];
      }
      else {
        if(key == 'options'){
          return field[key].map((item, index) => { return { value: index, label: item.value }; });
        }
        else if(key == 'defaultOptions'){
          return field['options'].map((item, index) => { return { value: item.value, label: item.value }; });
        }
        else {
          return field[key];
        }
      }
    }
    else {
      if(key == 'options'){
        return field[key].map((item, index) => { return { value: index, label: item.value }; });
      }
      else if(key == 'defaultOptions'){
        return field['options'].map((item, index) => { return { value: item.value, label: item.value }; });
      }
      else {
        return field[key];
      }
    }
  }

  render() {
    return (
      <DynamicFormBuilderScreenContext.Provider value={this.state}>
        {this.props.children}
      </DynamicFormBuilderScreenContext.Provider>
    );
  }
}

export const DynamicFormScreenContextAPIShape = PropTypes.shape({
  init: PropTypes.func.isRequired,
  onDFBasicValueChange: PropTypes.func.isRequired,
  onDFErrorChange: PropTypes.func.isRequired,
  onSectionValueChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  getValidFieldsForConditions: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  onChangeSectionOrder: PropTypes.func.isRequired,
  onChangeFieldOrder: PropTypes.func.isRequired,
  getComponentId: PropTypes.func.isRequired,
  onAddNewField: PropTypes.func.isRequired,
  onRemoveField: PropTypes.func.isRequired,
  onRemoveSection: PropTypes.func.isRequired,
  onAddNewSection: PropTypes.func.isRequired,
  getAllSections: PropTypes.func.isRequired,
  onCloneField: PropTypes.func.isRequired,
  onCloneSection: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
});
